import { useState, useEffect } from "react";
import { useGenericManager } from "spark-core-dx/hooks";
import { ItemServiceFactory } from "../../../services/ItemServiceFactory";

export const useDashboardUserState = (profileId, activeTabId) => {
        const itemServiceFactory = new ItemServiceFactory();
    const userDashStateMgr = useGenericManager(itemServiceFactory.ItemServiceEnum.UserDashboardState);
    const [userDashStates, setUserDashStates] = useState([]);

    const [isLoading, setIsLoading] = useState(true);

    // Initialization
    useEffect(() => {
        if(profileId)
            initializeUserDashState();
    }, [profileId]);

    const initializeUserDashState = async () => {
        if(profileId){
            const result = await userDashStateMgr.Query({
                model: "x => x.UserId == profileId",
                params: { profileId },
            });

            setUserDashStates(
                result?.Success && (result.Items?.length > 0 ? result.Items : [])
            );
            
            setIsLoading(false);
        }
    };

    const saveUserDashState = async (dashState) => {
        await userDashStateMgr.saveItem(dashState);
    }

    const activeUserDashState = userDashStates ? userDashStates?.find((x) => x.DashboardId === activeTabId) : null;

    return {
        activeUserDashState,
        userDashStates,
        setUserDashStates,
        saveUserDashState,
        isLoading
    };
};
